export default __webpack_public_path__ + "static/media/pdf-icon.9ea2ac53.svg";